import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';
import AbstractApiService from 'src/services/abstractApiService';
import {
  setprefSettings,
  setprefstrSettings,
  getprefSettings,
} from 'src/types';

export default class OrgPreferenceApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getOrgPref(data: getprefSettings): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.get_org_pref, formData);
  }

  public async getOrgPrefV2(data: getprefSettings): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.get_org_pref_v2, formData);
  }

  public async setOrgPref(data: setprefSettings): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.set_org_pref, formData);
  }

  public async setOrgstrPref(data: setprefstrSettings): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.post(api.set_org_pref, formData);
  }

  public async setBODConnectionStreamPref(data: dynamicObj): Promise<any> {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
      formData.append(key, value);
    }
    return super.put(api.set_bod_connection_stream_preference, formData);
  }

  public async getBODConnectionStreamPref(): Promise<any> {
    return super.get(api.get_bod_connection_stream_preference);
  }

  public async getSupportedBarcodeTypes(): Promise<any> {
    return super.get(api.get_supported_barcode_types);
  }

  public async validatePatterns(formData: FormData): Promise<any> {
    return super.post(api.validate_patterns, formData);
  }
}
